import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const initialState = {
    class: '',
    exam: '',
    loading: false,
};

const reducer = (state, action) => {
    if (action.type === 'RESET') return { ...initialState };
    return { ...state, [action.type]: action.value };
};

const SetCurrentExam = ({classExamInfo}) => {
    const [currentNotify, setNotify] = useState(null);
    const { getAssessments, assessmentList, getCurrentClassExams } = useConfig();
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        getAssessments();
    }, []);

    useEffect(() => {
        if (currentNotify) {
            const timeout = setTimeout(() => setNotify(null), 5000);
            return () => clearTimeout(timeout);
        }
    }, [currentNotify]);

    const handleSave = async (event) => {
        event.preventDefault();
        if (state.loading) return;

        if (!state.exam?.value) {
            setNotify(<Notification type="danger" message="Please select an exam/assessment." />);
            return;
        }

        dispatch({ type: 'loading', value: true });

        const server_response = await ajaxConfig.setCurrentExam(classExamInfo.class?.class_id, state.exam.value);
        dispatch({ type: 'loading', value: false });

        if (server_response.status === 'OK') {
            setNotify(<Notification type="success" message={server_response.message} />);
            getCurrentClassExams(true);
        } else {
            setNotify(<Notification type="danger" message={server_response.message} />);
        }
    };

  
    const renderExamSelector = () => {
        const options = [];
        if (Array.isArray(assessmentList)) {
            assessmentList.forEach(e =>
                options.push({
                    label: `${e.exam_name} (${e.assessment_type?.type_name || 'N/A'})`,
                    value: e.id
                })
            );
        }

        return (
            <TextInput
                label="Exam"
                type="select"
                leftIcon={true}
                placeholder={state.exam.label || 'Select exam...'}
                options={options}
                onChange={(item) => dispatch({ type: 'exam', value: item })}
                leftComponent={<i className="fa fa-edit"></i>}
                loading={!assessmentList}
                wrap
            />
        );
    };

    return (
        <div className="card-body">
            <CallOut
                title="Set Current Exam"
                description="Link an exam to a class for the current academic period."
            />

            {currentNotify}

            <form className="form-horizontal" onSubmit={handleSave}>
                {renderExamSelector()}

                <div className="text-right mt-3">
                    {!state.loading && (
                        <button type="submit" className="btn btn-lg btn-primary">
                            Set Exam
                        </button>
                    )}
                    {state.loading && <ActivityLoader />}
                </div>
            </form>
        </div>
    );
};

export default SetCurrentExam;
